/**
 * @param value is allowed to contain nan values
 */
export function toDOMPointInit(value, defaultW = 1) {
    if (value == null) {
        return undefined;
    }
    return {
        x: nanToDefault(value.x),
        y: nanToDefault(value.y),
        z: nanToDefault(value.z),
        w: 'w' in value ? nanToDefault(value.w, defaultW) : defaultW,
    };
}
export function nanToDefault(value, defaultValue = 0) {
    if (isNaN(value)) {
        return defaultValue;
    }
    return value;
}
